import { useCallback, useEffect, useState } from 'react'

export const DOCS_SCROLLABLE_CONTENT_ID = 'docs-content'

export function useTableOfContents(tableOfContents) {
  const [currentSection, setCurrentSection] = useState(tableOfContents[0]?.id)

  const getHeadings = useCallback(tableOfContents => tableOfContents
    .flatMap(node => [node.id, ...node.children.map(child => child.id)])
    .map((id) => {
      const el = document.getElementById(id)
      if (!el) { return }

      const style = window.getComputedStyle(el)
      const scrollMt = parseFloat(style.scrollMarginTop)
      const containerEl = document.getElementById(DOCS_SCROLLABLE_CONTENT_ID) as HTMLDivElement

      const top = containerEl?.scrollTop + el.getBoundingClientRect().top - scrollMt
      return { id, top }
    }), [])

  useEffect(() => {
    if (tableOfContents.length === 0) { return }
    const headings = getHeadings(tableOfContents)
    function onScroll() {
      const containerEl = document.getElementById(DOCS_SCROLLABLE_CONTENT_ID) as HTMLDivElement
      if (!containerEl) { return }

      const top = containerEl.scrollTop
      let current = headings[0]?.id
      for (const heading of headings) {
        const headingTop = heading?.top - containerEl.getBoundingClientRect()?.top - 1 //adjustment to account for scroll spacing and the top bar
        if (top >= headingTop) {
          current = heading.id
        } else {
          break
        }
      }
      setCurrentSection(current)
    }
    document.getElementById(DOCS_SCROLLABLE_CONTENT_ID)?.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => {
      document.getElementById(DOCS_SCROLLABLE_CONTENT_ID)?.removeEventListener('scroll', onScroll)
    }
  }, [getHeadings, tableOfContents])

  return currentSection
}